/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_R_Tutorial_DInputs */

const en_mk_nav_r_tutorial_d = /** @type {(inputs: Mk_Nav_R_Tutorial_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From sign-up to your first agent finishing a task.`)
};

const id_mk_nav_r_tutorial_d = /** @type {(inputs: Mk_Nav_R_Tutorial_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari daftar akun sampai agen pertama bekerja.`)
};

/**
* | output |
* | --- |
* | "From sign-up to your first agent finishing a task." |
*
* @param {Mk_Nav_R_Tutorial_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_r_tutorial_d = /** @type {((inputs?: Mk_Nav_R_Tutorial_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_R_Tutorial_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_r_tutorial_d(inputs)
	return en_mk_nav_r_tutorial_d(inputs)
});